import { render, staticRenderFns } from "./SearchObjectsList.vue?vue&type=template&id=6f5c9ea3&scoped=true&"
import script from "./SearchObjectsList.vue?vue&type=script&lang=ts&"
export * from "./SearchObjectsList.vue?vue&type=script&lang=ts&"
import style0 from "./SearchObjectsList.vue?vue&type=style&index=0&id=6f5c9ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c9ea3",
  null
  
)

export default component.exports